import { render, staticRenderFns } from "./b2b-data-table.vue?vue&type=template&id=2ce6f0e8"
import script from "./b2b-data-table.vue?vue&type=script&lang=js"
export * from "./b2b-data-table.vue?vue&type=script&lang=js"
import style0 from "./b2b-data-table.vue?vue&type=style&index=0&id=2ce6f0e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports